// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/* eslint-disable @typescript-eslint/naming-convention */
import {
  Currency,
  LanguageCode,
  LocationCode,
} from '@geneplanet/ngx-utils/src/lib/localization';

export const environment = {
  production: false,
  environment: 'local',
  language: 'en',
  locations: [
    {
      code: LocationCode.EU,
      currency: Currency.EUR,
      partner: {
        id: 'b17b988b-c11e-4460-a355-c42a98acd334',
        landingId: '0d03994c-fc39-4521-9185-6cc642789e8e',
      },
      lang: {
        videoSubtitles: false,
        code: LanguageCode.EN,
        longCode: 'English',
        name: 'English',
      },
    },
    {
      code: LocationCode.CH,
      currency: Currency.CHF,
      partner: {
        id: '74a1578a-97b0-4d58-8eb6-e2e987f5e19a',
      },
      lang: {
        videoSubtitles: false,
        code: LanguageCode.EN,
        longCode: 'English',
        name: 'English',
      },
    },
    {
      code: LocationCode.UK,
      currency: Currency.GBP,
      partner: {
        id: '77b49670-9312-4863-a457-e18259c96b7f',
      },
      lang: {
        videoSubtitles: false,
        code: LanguageCode.EN,
        longCode: 'English',
        name: 'English',
      },
    },
    {
      code: LocationCode.US,
      currency: Currency.USD,
      partner: {
        id: '1f592808-3675-4165-b5a7-ba35161eca83',
      },
      lang: {
        videoSubtitles: false,
        code: LanguageCode.EN,
        longCode: 'English',
        name: 'English',
      },
    },
    {
      code: LocationCode.PL,
      currency: Currency.PLN,
      partner: {
        id: '26f4e53a-0e91-43d7-bf31-5b23d8295a80',
      },
      lang: {
        videoSubtitles: true,
        code: LanguageCode.PL,
        longCode: 'Polish',
        name: 'Polski',
      },
      paymentMethods: {
        blik: true,
        mediraty: true,
      },
    },
    {
      code: LocationCode.SK,
      currency: Currency.EUR,
      partner: {
        id: 'b17b988b-c11e-4460-a355-c42a98acd334',
      },
      lang: {
        videoSubtitles: true,
        code: LanguageCode.SK,
        longCode: 'Slovak',
        name: 'Slovenský',
      },
    },
    {
      code: LocationCode.SL,
      currency: Currency.EUR,
      partner: {
        id: 'b17b988b-c11e-4460-a355-c42a98acd334',
      },
      lang: {
        videoSubtitles: true,
        code: LanguageCode.SL,
        longCode: 'Slovenian',
        name: 'Slovenščina',
      },
    },
    {
      code: LocationCode.TH,
      currency: Currency.EUR,
      name: 'Thai',
      customFlag: 'th',
      partner: {
        id: '',
      },
      lang: {
        videoSubtitles: false,
        code: LanguageCode.TH,
        longCode: 'Thai',
        name: 'แบบไทย',
      },
    },
  ],
  project: 'application',
  unitSystems: ['Metric', 'Imperial'],
  applicationId: '8968825b-a46c-4624-9160-dd5be80e79c4',
  api: 'https://api-stg.geneplanet.com/api/health-intelligence',
  apiUrl: 'https://api-stg.geneplanet.com',
  jotformApiKey: 'c1928dc4d96f4dbf1741389e6af0649f',
  auth0: {
    audience: 'https://geneplanet-platform-stg',
    domain: 'geneplanet-stg.eu.auth0.com',
    clientID: 'qI8UWmidt4khz5As8MGMrrajd1UnKzDM',
    responseType: 'token token_id',
  },
  pages: {
    home: 'https://web-stg.geneplanet.com/',
    about: 'https://web-stg.geneplanet.com/who-we-are/',
    contact: 'https://web-stg.geneplanet.com/contact/',
    press: 'https://hub.geneplanet.com/{lang}/press',
    careers: 'https://web-stg.geneplanet.com/careers/',
    business: 'https://web-stg.geneplanet.com/business/about',
    science: 'https://web-stg.geneplanet.com/science/',
    blog: 'https://hub.geneplanet.com/{lang}',
    help: 'https://hub.geneplanet.com/{lang}/help/',
    terms: 'https://web-stg.geneplanet.com/terms-and-conditions/',
    privacy: 'https://web-stg.geneplanet.com/privacy-policy/',
    cookie: 'https://web-stg.geneplanet.com/cookie-policy/',
    twitter: 'https://twitter.com/GenePlanet',
    facebook: 'https://www.facebook.com/GenePlanet-109182519106437/',
    instagram: 'https://www.instagram.com/geneplanet/',
    linkedin: 'https://www.linkedin.com/company/geneplanet',
    youtube: 'https://www.youtube.com/channel/UCvkfGs6Fx6UkxTmXmgOHOFg',
    lifestyle: 'https://web-stg.geneplanet.com/tests/dna-lifestyle',
    clinical: 'https://web-stg.geneplanet.com/tests/dna-clinical',
    blood: 'https://web-stg.geneplanet.com/tests/blood',
    workplacewellness:
      'https://web-stg.geneplanet.com/business/workplace-wellness',
    insurance: 'https://web-stg.geneplanet.com/business/insurance',
    laboratories: 'https://web-stg.geneplanet.com/business/laboratories',
    gymplanet: 'https://web-stg.geneplanet.com/business/gymplanet',
  },
  productApi: 'https://api-stg.geneplanet.com/api',
  publicApi: 'https://api-stg.geneplanet.com/open-products',
  dashboardUrl: 'https://hi-dev.geneplanet.com/',
  dashboardHealthScoreUrl:
    'https://hi-dev.geneplanet.com/healthscore/questionnaire/welcome',
  websiteUrl: 'https://web-dev.geneplanet.com',
  GpPartnerId: 'b17b988b-c11e-4460-a355-c42a98acd334',
  GpSecurityCode: 'YTbDxWfyAd2fKgjLu2hxz8JWU7wDaHaBD/Z0yTMtQYtO6CdJlJZ7bA==',
  payment: {
    stripePK: 'pk_test_1cYPJEqUZNTLRf2bhxXBFHu3',
    PayPalClientId:
      'AReLbJyI42odsADLuSy5ok8OM-2LEKoGTLtaQlDC0yf_zwsRdtGaOwpVntygySlQh6xTR2HWTlekZv72',
    createOrderSessionUrl:
      'https://api-stg.geneplanet.com/payment-gateway/paypal',
    stripeUrl: 'https://api-stg.geneplanet.com/payment-gateway/stripe',
    mediratyUrl: 'https://api-stg.geneplanet.com/payment-gateway/mediraty',
  },
  products: {
    heartHealthBlood: '257db183-b25f-4fe9-a9c6-ce1f411bf16f',
    dietAndBodyWeightOLD: '3f89430e-8734-4a24-a7db-def65baebaef',
    heartHealthDnaOLD: '699817b5-a174-4087-ba78-f0248dc942eb',
    metabolismAndLifeStyleOLD: 'e0f7e3ab-4180-471d-8f25-f2d2499d3fa8',
    skinHealthAndAgeingOLD: '177af1c7-e2a4-477f-96e4-063ba193d0a2',
    sportsPerformanceOLD: '91ca77c9-080b-437c-a066-ca1478549940',
    vitaminsAndMineralsOLD: '0085103f-fda8-4334-b8f4-13b51554f7ab',
    premiumPackOLD: '2d7320cb-2723-4fc2-8cd2-773bfb2e038d',
    dietAndBodyWeight: '39fa3a61-5774-4a89-bfd8-30a215216f55',
    heartHealthDna: 'e019b6d3-76bc-484a-899f-d6896904aeb2',
    metabolismAndLifeStyle: '6df46849-967c-40d8-8f4f-4040460d5784',
    skinHealthAndAgeing: '10be2ae2-ef23-459f-a494-ed30a6fb7ec2',
    sportsPerformance: '40c3f266-1989-481e-b9e1-ebd111ced9ff',
    vitaminsAndMinerals: '3783116d-f522-4cbb-8168-4b74d22a1892',
    premiumPack: '749a82db-0f02-4335-8cbc-e2a16bdbc0ea',
    lifestyleQuestionnaire: 'aba840e3-77d9-4895-932e-c7e4b4410c12',
    mindAndWellbeing: '935afd2a-e8de-4a8d-9986-18e192523ee3',
    prsCancer: '90a39fad-1ae8-4dd0-80b7-5f3172825bf7',
    premiumPackSubscription: '78fb5c2c-c92b-45da-856e-5f14e49f2b95',
    myLifestyle: '839147b0-5051-4aa7-b8c0-462de147e8d6',
    myHealth: 'f9a2abd5-7130-4116-9ab2-1cf6bceaab6c',
    bodyAndMind: '29e5ba5f-1c33-410d-95af-3a841097c83f',
    sportAndRecreation: 'ba656910-7de8-49cc-965c-603183abcf86',
    dietAndNutrition: '7f279bde-d64f-4b4e-8390-ed29ac9839fe',
    immuneSystem: '3bfe2eee-ac64-4f82-b7ca-861538d82e65',
    physicalTraits: '5c94841b-7e7b-4acc-96c5-ae4d3ef0e95a',
    ancestry: '0ba5c89b-d7f1-4afd-89b4-28e56b3cbd73',
    myAncestry: 'fcb8906f-d742-4f3e-bccb-9c8535de6b5b',
    cardiovascularDisease: '9af73423-a558-4b05-9c7f-261558c962c2',
  },
  cancerProducts: {
    cancerScreenBasic: '620d5dfb-430e-4456-ad3b-b977dfd3daaa',
    cancerScreenStandard: '0c38f38c-6433-4dca-94b4-d3b6aafbf425',
    cancerScreenPlusFemale: 'f7a4ca2e-05b1-4f09-ba92-4d6754c0a39b',
    cancerScreenPlusMale: 'cda4f9ab-9503-4060-a9f1-fd987e05b2cb',
  },
  enabledProducts: {
    myLifestyle: true,
    myHealth: true,
    myOral: true,
    myAncestry: true,
  },
  outOfStockProducts: {
    heartHealthBlood: true,
  },
  categories: {
    family: '1a571e8e-83ae-4e45-a597-c0d23e3fe56c',
    nutrition: 'a15d32a2-9e1d-482d-a951-ea96274d4bd5',
    cancerScreen: 'a91e34ab-769e-4925-9008-3f77729871c7',
    skinAndBeauty: 'aa93a309-ed06-454a-b026-8c49e6df55b9',
    sportAndExercise: 'e67a9336-9857-40fd-9b99-d49408e09e20',
    heartHealth: 'f9f67900-5798-419f-baa3-fdbc12548be9',
    myAncestry: 'c1c19b40-1990-44e0-82f8-b1484e25f62f',
    myHealth: '95e8cce8-f00c-43c3-ab7b-8a39a06f7858',
    myLifestyle: '5275471e-727e-455c-b1b0-b9febf48fd0d',
    dnaTestResults: 'f34dc7cb-c941-4c06-bae4-fb2ae3add19f',
    myMicrobiome: 'e4e53777-42e7-4ea5-b776-6421e2ff7f19',
  },
  testTypes: {
    dnaClinical: '1748230e-7016-40d7-874c-be5de8935798',
    dnaLifestyle: '08ec94cd-574f-4721-930f-2ebd353d7b2a',
    blood: '508d657b-8679-4584-aa42-c4860806d118',
    questionnaire: '9bb7a48d-b03f-4d98-8153-6ce71ea1d4f9',
    measurement: 'ab04ef0a-2d8e-42d6-9738-b22d99c60c32',
    prs: 'e3665663-59c2-4b42-8e75-b735bc2da7f5',
  },
  hubspotForms: {
    portalId: '6124254',
    newsletter: 'b088669a-3dec-428a-ac67-c02f19ac0306',
    niptContactForm: '8f548558-ec7d-4473-b94f-9d667f41e225',
  },
  measurement: {
    bodyHeight: '35321d0b-9ecf-4d03-a07b-35e76352cfa7',
    bodyWeight: '2a6bdd92-5de0-410d-818d-d2221aab481f',
  },
  intents: {
    biolab: 'e8a49b68-148b-4876-bbd9-b36a0c8ed965',
    adrialab: 'cc3f2ed4-54d7-4cdb-af6b-246105ccdfc6',
    claimKit: '7f431adb-6df4-45db-a162-05d8d6bf6da4',
    claimKitInApp: '13c5db25-1b34-49f3-9289-e80e3e7685fd',
    dna: 'de535cef-9870-4332-ac97-1440459f9abb',
    blood: '8d7f9416-4706-42db-b3f5-597fd37508ae',
    nipt: '32e52887-daa8-4c84-93ca-83dfcc00b573',
  },
  ancestry: {
    ethnicity: 'e0c5397a-4e4a-4a9d-9c4a-b47de81a5e53',
    haplogroup: 'cff26ec9-d211-4f4b-a8f4-859a93e38287',
    chromosome: 'e6aab65f-4276-44de-9a19-2fca0ecf735f',
    neanderthal: 'ab31ddbf-958d-41b3-8e6d-b9e066559138',
  },
  mapbox: {
    accessToken:
      'pk.eyJ1IjoiZ2VuZXBsYW5ldCIsImEiOiJja292Ynd4cW4wMG8xMzByczZwOHl5c2EwIn0.PjrdiOINAmYPM77vEFi6aw',
    mapStyle:
      'mapbox://styles/geneplanet/ckp3t6z6707qv18ojqb942kc7?optimize=true',
  },
  features: {
    prs: true,
    prsDemo: true,
    wgs: true,
    nipt: true,
    foodid: true,
    resultsOverview: true,
    ancestry: true,
    oralMicrobiome: true,
    subscription: false,
    recipeGenerator: { [LocationCode.TH]: false },
    newPrs: { [LocationCode.TH]: false },
    shop: { [LocationCode.TH]: false },
  },
  sentry: {
    enabled: true,
    logUser: true,
    dns: 'https://6631a9964e7544a08b3ff9bb006aa52d@o468713.ingest.sentry.io/5515505',
  },
  rudderstackKey: '27SesS8osOMaO9o8F0ZYHrhImGW',
  rudderStackEnabled: false,
  gtmContainer: 'GTM-MNH4KPC',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
